/*注册全局的方法或者组件*/
const myPlugin = {
  install:function (Vue) {
    /**
     * 添加自定义指令
     */
    const handler = (e) => {
      e.preventDefault(); //阻止默认事件
    };
    Vue.directive('roll', {
      componentUpdated(el, binding) {
        if (binding.value) {
          document.getElementsByTagName('body')[0].addEventListener('touchmove', handler, { passive: false });//阻止默认事件
        } else {
          document.getElementsByTagName('body')[0].removeEventListener('touchmove', handler, { passive: false });//打开默认事件
        }
      }
    });

    Vue.directive('myBlur', {
      inserted(el, binding, vnode, oldVnode) {
        const myInput = document.getElementsByTagName('input')
        for (let i=0;i<myInput.length;i++) {
          myInput[i].onblur = function () {
            console.log('input失去焦距');
            window.scrollTo(0,0);
          }
        }
      }
    })

    //数字转换大写金额
    Vue.prototype.digitUppercase  = function(n) {
      let fraction = ['角', '分'];
      let digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
      ];
      let unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
      ];
      let head = n < 0 ? '欠' : '';
      n = Math.abs(n);
      var s = '';
      for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
      }
      s = s || '整';
      n = Math.floor(n);
      for (let i = 0; i < unit[0].length && n > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
      }
      return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
    };
    //将数字转换成金额显示
    Vue.prototype.toMoney = function (num){
      num =  Number(num).toFixed(2);     
      num = parseFloat(num)
      // num = num.toLocaleString();
      num = num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      // num = (num.toString().indexOf ('.') !== -1) ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      return num;//返回的是字符串23,245.12保留2位小数
    }

  }
};

export default myPlugin



// WEBPACK FOOTER //
// ./src/assets/js/myplugin.js